import { Component, OnInit, ViewChild, ElementRef, Directive } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonService } from '../../Services/common.service';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators, FormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { MatPaginator, MatSort, MatTableDataSource, ErrorStateMatcher } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { PhoneGradeService } from '../../Services/phone-grade.service';
import { ApiService } from '../../common/API/api.service';

declare var config: any;
@Component({
  selector: 'app-phone-grade',
  templateUrl: './phone-grade.component.html',
  styleUrls: ['./phone-grade.component.css']
})

export class PhoneGradeComponent implements OnInit {
  public dataTableID : any = 0;
  public IsSubmit = false;
  public displayedColumns = ['GradeID' ,'GradeName','PercentageDeduction'];
  //public users : IUsers[]= [];
  public dataSource : MatTableDataSource<any>;
  public UserFilterTxt : any = '';
  public AdminID : any;
  public ReportData : any;
  form: FormGroup;
  CurrentRole : any;
  usermangement : any =false;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('hiddenFormCloseButton') closeAddExpenseModal: ElementRef;
  @ViewChild('hiddenCloseButton') close: ElementRef;

  length = 0;
  pageSize = 10;
  pageSizeOptions = [5, 10, 25, 100 , 200 ,500 , 1000 , 5000];
  phonerecords:any[]=[];
  public DataList = [];
  public ShowUserdrp : any = false;
  public ShowRoledrp : any = true;
  public ShowTeamName : any = false;
  public RoleList : any;
  public TotalUserList : any;
  finalarray:any[];
  Enterprise: any;
  EnterpriseID: string;
  public Enterprisedata = [];
  Enterpriselist: any;
  public UserInfo: any;
  enterpriseClientData: any;
  UserData: any;
  EnterprisePartenerModalList: any;
  StoreDetails: any;
  AllStoreDetails: any;
  result: any;
  FrontendBackendDetails: any;
  FrontendData: any;
  BackendData: any;
  UpliftEnableGrades: any;
  IsEnableUplift: boolean=false;
  SelectModino: boolean = false;
  EnterprisePartnerID: any;
  disableReset: boolean = false;
  isFrontEndDeduction: boolean=true;
  FrontendBackendProfileID: any;
  isSaveBtnDisabled: boolean;
  constructor(private toasterservice: ToastrService,
    private phonegradeservice: PhoneGradeService,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private _service: CommonService,
    private router: Router,
    private _apiService: ApiService) {

  }
  ngOnInit() {
    debugger
    this.EnterprisePartnerID = 0;
    this.EnterpriseID = "1";
    this.Enterprise = config.Enterprise;
    this.UserInfo = JSON.parse(sessionStorage.getItem('userInfo'));
    this.disableReset = true;

    if (this.UserInfo == null) {
      //this.router.navigate(['/']);
    }
    debugger
    this.FrontendBackendDetails=config.FrontendBackendProfiles;
    this.UpliftEnableGrades=config.UpliftEnableFrontBackGrades;
    this.GetFrontBackProfileGrades(this.FrontendBackendDetails[0].FrontendBackendProfileID)
   // this.GetPhoneGradeList();
  }

  ShowUpdateModel(item)
  {

  }


GetPhoneGradeList(): void {
  debugger
    this.spinner.show();
  this._service.getgrade('api/phone-grade-list').then(res => {
   debugger
    this.phonerecords = res;
    this.spinner.hide();
    sessionStorage.setItem('array', JSON.stringify(this.phonerecords));
    this.dataSource=new MatTableDataSource(res);
    this.AllStoreDetails=res;
       this.dataSource.paginator = this.paginator;
       this.length=res.length;
       this.dataSource.sort = this.sort;
       this.spinner.hide();
  });
}
  PhoneGradeUpdateData(): void {
    debugger
    var updatedArray = [];
    this._service.getgrade('api/phone-grade-list').then(res => {
      this.result = res;
      for (let i = 0; i < this.result.length; i++) {

        if (this.result[i].Deduction !== this.phonerecords[i].Deduction ||
          this.result[i].IsActive !== this.phonerecords[i].IsActive) {
          const element = {
            EnterpriseID: config.EnterpriseID,
            GradeID: this.phonerecords[i].GradeID,
            Grade: this.phonerecords[i].GradeName,
            Deduction: this.phonerecords[i].Deduction,
            IsActive: this.phonerecords[i].IsActive ? 1 : 0
          };
          updatedArray.push(element);
        }

      }
      let isDataCorrect = true
      this.phonerecords.forEach(element => {
        if (element.Deduction.toString() == "" || Number(element.Deduction) > 100 || Number(element.Deduction)! < 0) {
          isDataCorrect = false;
          return;
        }
      });
      if (updatedArray.length == 0) {
        this.toasterservice.error('No Grades are changed');
        return;
      }
      if (isDataCorrect) {

        this.spinner.show();
        const param = {
          LogUpdate: updatedArray,
          PhoneGradeList: this.phonerecords
        };
        this._service.getPhoneData(param, 'api/update-phone-grades').then(res => {
          this.spinner.hide();
          if (res && res.LogUpdate) {
            this.finalarray = this.phonerecords;
            sessionStorage.setItem('array', JSON.stringify(this.finalarray));
            this.toasterservice.success('Grades deduction updated successfully');

          } else {
            this.finalarray = [];
            this.toasterservice.error('An error occured while updating data');

          }

        });
      }
    });

  }

  numbersonly(event: any) {
    debugger

    const pattern = /^\d*?(\d{0,2})?$/;
    const inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
    
   // event.charCode= (event.charCode).toFixed(0)
//console.log(num) 
  }

  IsActive(event, item) {
    item.IsActive = !item.IsActive;
  }

  preventCopyPaste(event) {
    debugger
    event.preventDefault();
  }

  GetFrontBackProfileGrades(FrontendBackendProfileID) {
    
    debugger
    this.FrontendBackendProfileID=FrontendBackendProfileID;
    if(this.EnterpriseID =="1")
    {
      this.EnterprisePartnerID ="2";
    }
    else if(this.EnterpriseID =="3")
    {
      this.EnterprisePartnerID ="23";
    }
    else if(this.EnterpriseID =="4")
    {
      this.EnterprisePartnerID ="27";
    }
    else if(this.EnterpriseID =="5")
    {
      this.EnterprisePartnerID ="29";
    }
    else if(this.EnterpriseID =="6")
    {
      this.EnterprisePartnerID ="30";
    }
      this.spinner.show();
      var param={
        "FrontendBackendProfileID":FrontendBackendProfileID,
        EnterprisePartnerID: this.EnterprisePartnerID,

      }
    this._service.getData(param,'api/FrontBackProfileGardes').then(res => {
     debugger
      if(FrontendBackendProfileID==this.FrontendBackendDetails[0].FrontendBackendProfileID){
        this.FrontendData= res.filter(x=>x.FrontendBackendProfileID==this.FrontendBackendDetails[0].FrontendBackendProfileID);
        
        this.spinner.hide();
        this.BackendData = '';
        this.dataSource=new MatTableDataSource(this.FrontendData);
        this.AllStoreDetails=this.FrontendData;
           this.dataSource.paginator = this.paginator;
           this.length=res.length;
           this.dataSource.sort = this.sort;
           this.spinner.hide();
      }
      else{

        this.BackendData= res.filter(x=>x.FrontendBackendProfileID==this.FrontendBackendDetails[1].FrontendBackendProfileID);
        this.spinner.hide();
        this.dataSource=new MatTableDataSource(this.BackendData);
        this.FrontendData = '';
        this.AllStoreDetails=this.BackendData;
           this.dataSource.paginator = this.paginator;
           this.length=res.length;
           this.dataSource.sort = this.sort;
           this.spinner.hide();
      }
    
    });
  }

  SaveUpdateFrontGrades(updatedDetails){
    debugger
    this.spinner.show();
    let gradeProfile = [];
    updatedDetails.forEach(element => {
      let ele = {
        FrontendBackendProfileID:element.FrontendBackendProfileID,
        GradeID:element.GradeID,
        GradeName:element.GradeName,
        PercentageDeduction:element.PercentageDeduction,
        Uplift:element.Uplift
      }
      gradeProfile.push(ele);
    });
    let obj = {
      FrontendBackendProfileID: this.FrontendBackendProfileID,
      EnterprisePartnerID: this.EnterprisePartnerID,
      GradeProfileType: gradeProfile
    }
    this._service.getPhoneData(obj, 'api/SaveUpdateFrontBackGrades').then(res => {
      this.spinner.hide();
      if (res!=null) {
        // this.FrontendData=res;
        // updatedDetails=[];
        this.toasterservice.success('Frontend Grades deduction updated successfully');

      } else {
        // updatedDetails=[];
        this.toasterservice.error('An error occured while updating data');

      }

    });
  }

  SaveUpdateBackGrades(updatedBackDetails){
    debugger
    this.spinner.show();
    let gradeProfile = [];
    updatedBackDetails.forEach(element => {
      let ele = {
        FrontendBackendProfileID:element.FrontendBackendProfileID,
        GradeID:element.GradeID,
        GradeName:element.GradeName,
        PercentageDeduction:element.PercentageDeduction,
        Uplift:element.Uplift
      }
      gradeProfile.push(ele);
    });
    let obj = {
      FrontendBackendProfileID: this.FrontendBackendProfileID,
      EnterprisePartnerID: this.EnterprisePartnerID,
      GradeProfileType: gradeProfile
    }
    this._service.getPhoneData(obj, 'api/SaveUpdateFrontBackGrades').then(res => {
      this.spinner.hide();
      if (res !=null) {
        // this.BackendData= res;
        this.toasterservice.success('Backend Grades deduction updated successfully');

      } else {
        // this.finalarray = [];
        this.toasterservice.error('An error occured while updating data');

      }

    });
  }
  FrontUpdate(event,demo: any,check)
  {
    debugger
    if(check == 'Percentage')
    {
      this.FrontendData.filter(x=> x.GradeID == demo.GradeID)[0].PercentageDeduction = (event.target.value)

    }
    if(check == 'Uplift')
    {
      this.FrontendData.filter(x=> x.GradeID == demo.GradeID)[0].Uplift = (event.target.value)

    }
   
  }
  BackUpdate(event,demo: any,check)
  {
    debugger
    if(check == 'Percentage')
    {
      this.BackendData.filter(x=> x.GradeID == demo.GradeID)[0].PercentageDeduction = (event.target.value)

    }
    if(check == 'Uplift')
    {    
        this.BackendData.filter(x=> x.GradeID == demo.GradeID)[0].Uplift = (event.target.value)
    }
   
  }
  onChangeEnterprise(event) {
    debugger
    if (event == "0") {
      return false;
    }

    else if (event == "1"  || event == "4" || event == "5") {
      this.SelectModino = false;
      // this.disableReset = false;
      this.FrontendBackendDetails=config.FrontendBackendProfiles;
      this.GetFrontBackProfileGrades(this.FrontendBackendDetails[0].FrontendBackendProfileID)
    }
    else{
      //this.dataSource ='';
      this.SelectModino = true;
      this.EnterprisePartnerID = "0";
      this.disableReset = false;
      this.isSaveBtnDisabled=true;
      this.getEnterprise_EnterprisePartner();
   
    
    }
   
   
  }

  OnChangeEnterprisePartner(PartnerID)
  {
    // this.dataSource ='';
    this.isSaveBtnDisabled=false;
    this.FrontendBackendDetails=config.FrontendBackendProfiles;
    this.GetFrontBackProfileGrades(this.FrontendBackendDetails[0].FrontendBackendProfileID)
    //  this.disableReset = false;
  }

 
  getEnterprise_EnterprisePartner() {
    this.spinner.show();
    this._apiService.get(config.WebApiPath + 'api/support-tool/get-store').subscribe(result => {
      this.spinner.hide();
      if (result.IsSuccess) {
        this.Enterpriselist = result.Data.Table1.filter(X => X.IsActive !== false);
        this.Enterprisedata = result.Data.Table2.filter(X => X.EnterpriseID == this.EnterpriseID && X.IsActive !== false);
      }
    },
      error => {
        console.log(error);
      }
    );
  
  }
  resetfilter() {
    this.spinner.show();

  
    this.EnterprisePartnerID = "0";
    this.EnterpriseID = "1";
     this.SelectModino = false;
     //this.dataSource ='';
  
    this.FrontendBackendDetails=config.FrontendBackendProfiles;
    this.GetFrontBackProfileGrades(this.FrontendBackendDetails[0].FrontendBackendProfileID)
  
  }
}



